import React from 'react';
import { NavLink } from 'react-router-dom';
import { Container, Row, Col } from 'react-bootstrap';

const HomeApparel = () => {
  return (
    <Container className='HomeApparel pt-5' fluid>
      <Container className=' mt-5'>
        <Row>
          <Col md={7} className='HomeApparel-heading p-2'>
            <div>Apparel</div>
          </Col>
          <Col className=' p-2'>
            <p>
              A blend of street culture and futuristic design - a distinctive
              style of clothing for our music community around the world
            </p>
            <NavLink to='/apparel' className='btn btn-theam'>
              See the collection
            </NavLink>
          </Col>
        </Row>
      </Container>
    </Container>
  );
};
export default HomeApparel;
